import { Component, OnInit } from '@angular/core';
import { FezaDataService } from '../../services/fezadata.service';
import { LogDTO } from '../../models/ILogDTO';
import { Observable } from 'rxjs';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { stringify } from '@angular/core/src/util';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-error-viewer',
    templateUrl: './log-viewer.component.html',
    styleUrls: ['./log-viewer.component.css']
})
export class LogViewerComponent implements OnInit {

    logs: LogDTO[];
    correlationId: string;
    noOfErrors: number;
    dateStart: Date;
    dateEnd: Date;

    constructor(private dataService: FezaDataService, public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            this.correlationId = params['correlationId'];
            if (typeof(this.correlationId) != 'undefined' && this.correlationId.length > 0) this.onChangeCorrelationId();
          });
    }

    ngOnInit() { }

    onChangeCorrelationId() {
        this.dataService.GetLogs(this.correlationId).subscribe(dataFromServer => {
            if (dataFromServer.length <= 0) { 
                alert(`No logs had been found for ${this.correlationId}`);
                return;
            };
            this.logs = dataFromServer;
            this.noOfErrors = this.logs.filter(l => l.level == "Error").length;
            this.logs.sort((a, b) => new Date(a.timeStamp).getTime() - new Date(b.timeStamp).getTime());
            this.dateStart = this.logs[0].timeStamp;
            this.dateEnd = this.logs[this.logs.length - 1].timeStamp;
        });
    }

    KeepJsonOnly(text: string) {
        var start = text.indexOf("{");
        var end = text.lastIndexOf("}") + 1;

        if (end == text.length && start > 0) {
            return text.substr(start, end - start);
        }
        return text;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/log-viewer/log-viewer.component.ts